export const InvenTory =
{ // dashboard object start
  path: '/inventory',
  component: () => import('@/View/InvenTory/layout/Layout.vue'),
  hidden: false,
  redirect: '/inventory/dashboard',
  name: 'InvenTory',
  meta: {
    breadCrumb: 'Dashboards',
    title: 'Dashboards',
    icon: 'dashboard',
    selected: false,
    permission: ['abc', 'def']
  },
  children: [{
    path: 'dashboard',
    icon: 'dashboard',
    component: () => import('@/View/InvenTory/Dashboard/dashboard.vue'),
    name: 'Dashboards',
    meta: {
      breadCrumb: 'Dashboard',
      title: 'Dashboard',
      icon: 'dashboard',
      permissionList: ['abc', 'def']
    }
  },
  { // Warehouse List page
    path: 'warehouse',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'Warehouse'},
    name: 'IWarehouse',
    meta: {
      breadCrumb: 'Warehouse',
      title: 'Warehouse',
      icon: 'fas fa-warehouse',
      selected: false,
      permissionList: ['isViewAll', 'isViewRelated'],
      permissionSlug: 'warehouse'
    },
    children: [{
      path: 'list',
      component: () => import('@/View/InvenTory/Warehouse/wareHouseList.vue'),
      name: 'Warehouse',
      meta: {
        breadCrumb: 'Warehouse',
        icon: 'fa fa-warehouse',
        title: 'List',
        permissionSlug: 'warehouse'
      }
    },
    {
      path: 'new',
      component: () => import('@/View/InvenTory/Warehouse/NewWarehouse.vue'),
      name: 'NewWarehouse',
      meta: {
        breadCrumb: 'New Warehouse',
        icon: 'fa fa-user',
        title: 'Add',
        permissionSlug: 'warehouse'
      }
    },
    { // Warehouse Details page
      path: 'details/:warehouseId',
      component: () => import('@/View/InvenTory/Warehouse/WarehouseDetails.vue'),
      hidden: true,
      name: 'WarehouseDetail',
      meta: {
        breadCrumb: 'Warehouse Detail',
        title: 'Details',
        selected: '',
        permissionSlug: 'warehouse'
      }
    }]
  },
  { // Material List page
    path: 'material',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'Material'},
    name: 'RowMaterial',
    meta: {
      breadCrumb: 'Material',
      title: 'Material',
      icon: 'fas fa-box',
      selected: false,
      permissionList: ['isViewAll', 'isViewRelated'],
      permissionSlug: 'raw_material'
    },
    children: [{
      path: 'list',
      component: () => import('@/View/InvenTory/RowMaterial/RowMaterials.vue'),
      name: 'Material',
      meta: {
        breadCrumb: 'RowMaterialList',
        icon: 'fas fa-industry',
        title: 'List'
      }
    },
    { // New materisl  page
      path: 'new/:materialId',
      component: () => import('@/View/InvenTory/RowMaterial/NewRowMaterisl.vue'),
      hidden: true,
      icon: 'fas fa-file-invoice-dollar',
      name: 'NewRowMaterial',
      meta: {
        breadCrumb: 'NewRowMaterial',
        title: 'Add',
        selected: '',
        permissionSlug: 'raw_material'
      }
    },
    { // New materisl  page
      path: 'details/:materialId',
      component: () => import('@/View/InvenTory/RowMaterial/RowMaterialDetails.vue'),
      hidden: true,
      icon: 'fas fa-file-invoice-dollar',
      name: 'RowMaterialDetails',
      meta: {
        breadCrumb: 'Raw Material Details',
        title: 'Details',
        selected: '',
        permissionSlug: 'raw_material'
      }
    }]
  },
  // Raw MaterialReoder page
  {
    path: 'materialreorder',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'MaterialReorder'},
    name: 'RawMaterialReorder',
    meta: {
      breadCrumb: 'MaterialReorder',
      title: 'Material Reorder',
      icon: 'fas fa-box-open',
      selected: false,
      permissionList: ['isViewAll', 'isViewRelated'],
      permissionSlug: 'raw_inventory'
    },
    children: [{
      path: 'list',
      component: () => import('@/View/InvenTory/MaterialReorder/MaterialReorderList.vue'),
      name: 'MaterialReorder',
      meta: {
        breadCrumb: 'MaterialReorder',
        icon: 'fas fa-box-open',
        title: 'List'
      }
    },
    {
      path: 'details/:materialId',
      component: () => import('@/View/InvenTory/MaterialReorder/MaterialReorderDetails.vue'),
      hidden: true,
      icon: 'fas fa-file-invoice-dollar',
      name: 'MaterialReorderDetails',
      meta: {
        breadCrumb: 'Material Reorder Details',
        title: 'Details',
        selected: '',
        permissionSlug: 'raw_material'
      }
    }]
  },
  { // Inventory Raw Material List page
    path: 'inventory',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'InventoryListComponent'},
    name: 'InventoryList',
    meta: {
      breadCrumb: 'Inventory',
      title: 'Inventory',
      icon: 'fa fa-cart-plus',
      selected: false,
      permissionList: ['isViewAll', 'isViewRelated'],
      permissionSlug: 'raw_material_inventory'
    },
    children: [{
      path: 'list',
      component: () => import('@/View/InvenTory/InventoryRawmaterial/InventorRawMaterisl.vue'),
      name: 'InventoryListComponent',
      meta: {
        breadCrumb: 'InventoryList',
        icon: 'fa fa-cart-plus',
        title: 'List'
      }
    },
    { // Inventory Raw Material List page
      path: 'new',
      component: () => import('@/View/InvenTory/InventoryRawmaterial/NewInventoryMaterial.vue'),
      hidden: true,
      icon: 'fas fa-industry',
      name: 'NewInventory',
      meta: {
        breadCrumb: 'New Inventory',
        icon: 'fas fa-industry',
        title: 'Add',
        selected: '',
        permissionSlug: 'raw_material_inventory'
      }
    },
    { // New materisl  page
      path: 'details/:rawMaterialId',
      component: () => import('@/View/InvenTory/InventoryRawmaterial/MaterialInventoryDetails.vue'),
      hidden: true,
      icon: 'fas fa-file-invoice-dollar',
      name: 'MaterialInventoryDetails',
      meta: {
        breadCrumb: 'Inventory Detail',
        title: 'Details',
        selected: '',
        permissionSlug: 'raw_material_inventory'
      }
    }]
  },
  { // activityLog page
    path: 'activityLog',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'activityLog'},
    name: 'IactivityLog',
    meta: {
      breadCrumb: 'Activity Log',
      title: 'Activity Log',
      icon: 'fas fa-clock',
      selected: false,
      permissionList: ['abc', 'def']
    },
    children: [{
      path: '',
      component: () => import('@/View/InvenTory/ActivityLog/index.vue'),
      name: 'activityLog',
      meta: {
        breadCrumb: 'Activity Log',
        icon: 'fas fa-clock',
        title: 'Activity Log',
        permissionList: ['abc', 'def']
      }
    }]
  },
  { // Item page
    path: 'item',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'Item'},
    name: 'IItem',
    meta: {
      breadCrumb: 'Item',
      title: 'Item',
      icon: 'fa fa-object-group',
      selected: false,
      permissionList: ['isViewAll', 'isViewRelated'],
      permissionSlug: 'item_management'
    },
    children: [{
      path: 'list',
      component: () => import('@/View/InvenTory/Item/ItemList.vue'),
      name: 'Item',
      meta: {
        breadCrumb: 'Item',
        icon: 'fa fa-object-group',
        title: 'List',
        permissionList: ['isViewAll', 'isViewRelated']
      }
    },
    {
      path: 'new/:itemId/:from',
      component: () => import('@/View/InvenTory/Item/NewItem.vue'),
      name: 'NewItem',
      meta: {
        breadCrumb: 'New Item',
        icon: 'fas fa-clock',
        title: 'Add',
        permissionList: ['isViewAll', 'isViewRelated']
      }
    },
    {
      path: 'details/:itemId',
      component: () => import('@/View/InvenTory/Item/Itemdetails.vue'),
      name: 'ItemDetails',
      meta: {
        breadCrumb: 'Item Details',
        icon: 'fas fa-clock',
        title: 'Details',
        permissionList: ['isViewAll', 'isViewRelated']
      }
    }]
  },
  { // Setting object start
    path: 'settings',
    component: () => import('@/View/InvenTory/main/index.vue'),
    hidden: false,
    redirect: {name: 'settings'},
    name: 'InventorySetting',
    meta: {
      breadCrumb: 'settings',
      title: 'Settings',
      icon: 'fa fa-cog',
      selected: false,
      permissionSlug: 'inventory_settings',
      permissionList: ['']
    },
    children: [{
      path: 'dashboard',
      component: () => import('@/View/InvenTory/Setting/Setting.vue'),
      name: 'settings',
      hidden: true,
      meta: {
        icon: 'fa fa-cog',
        title: 'Dashboard',
        permissionList: ['']
      }
    },
    { // StoreTypeList List page
      path: 'storetype',
      component: () => import('@/View/InvenTory/main/index.vue'),
      hidden: false,
      redirect: {name: 'StoreTypeList'},
      name: 'IStoreTypeList',
      icon: 'fas fa-store',
      meta: {
        breadCrumb: 'Store Types',
        title: 'Store Types',
        color: '#26c6da',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'store_types'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/InvenTory/Setting/StoreType/StoreType.vue'),
        name: 'StoreTypeList',
        hidden: true,
        meta: {
          icon: 'fa fa-cog',
          title: 'Store Types',
          selected: false,
          permissionList: 'store_types'
        }
      }]
    },
    { // UnitList List page
      path: 'unit',
      component: () => import('@/View/InvenTory/main/index.vue'),
      hidden: false,
      redirect: {name: 'UnitList'},
      name: 'IUnitList',
      icon: 'fas fa-balance-scale',
      meta: {
        breadCrumb: 'Unit List',
        title: 'Unit List',
        color: '#07575b',
        selected: false,
        permissionList: ['isViewAll'],
        permissionSlug: 'material_unit'
      },
      children: [{
        path: 'list',
        component: () => import('@/View/InvenTory/Setting/materialUnit/MaterialUnit.vue'),
        name: 'UnitList',
        meta: {
          breadCrumb: 'Unit List',
          icon: 'fas fa-store',
          title: 'Unit List',
          permissionSlug: 'material_unit'
        }
      }]
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/View/InvenTory/Router/index.js